<template>

	<hit_login>

    <hit_dashboard >

			<div class="hit-form-group" v-if="get_limit() === 0 || get_limit() > $store.getters.boards.length">
				<a href="#" class="hit-btn hit-btn-warning" v-on:click.prevent="add_new_board()">{{ $t("message.createNew", {name: $tc("message.board", 1)}) }}</a>
			</div>

			<div class="hit-form-group" v-if="$store.getters.boards.length">

					<div class="hit-panel hit-panel-warning">
					<div class="hit-panel-heading">

						<h4 class="hit-html-h4" v-if="!action"><hit_limit v-bind:key="table_key" :settings="{id:'get_board_limits'}" /> {{ $tc('message.board', $store.getters.boards.length  ) }}</h4>
						<h4 class="hit-html-h4" v-if="action">{{ Object.values($store.getters.boards)[edit.row].name }}</h4>

					</div>
					<div class="hit-panel-body">
						<transition name="fade" v-if="!action && get_data()" >

						<hit_table
						v-bind:key="table_key"
						:titles="Object.keys(get_data()[0])"
						:data="get_data()"
						:actions="[
						false,
						function(value, row, column){ get_details(value, row, column, 'board_title') },
						function(value, row, column){ get_details(value, row, column,  'board_questions') },
						function(value, row, column){ get_details(value, row, column,  'board_password') },
						function(value, row, column){ change_route(value, row, column,  'board_settings') },
						function(value, row, column){ set_clone_board(row) },
						 false, false, false]"
						:icons="['','group-chat','question-sign','lock','cogwheel']"
						/>

					</transition>

							<component v-if="edit" v-bind:is="action" :edit="edit" />

						</div>

					<div class="hit-panel-footer" v-if="action">
						<div class="hit-text-left">
							<a href="#" class="hit-html-a" v-on:click.prevent="remove_action()">{{ $t("message.goTo", {name: $t("message.boardOverview")}) }}</a>
						</div>
					</div>
					</div>
			</div>

    </hit_dashboard>

  </hit_login>

</template>

<script>

import board_title from '@core/components/content/app/board/board_title'
import board_password from '@core/components/content/app/board/board_password'
import board_questions from '@core/components/content/app/board/board_questions'
import board_settings from '@core/components/content/app/board/board_settings'

export default {
  components: {board_title, board_password, board_questions, board_settings},

  data: function () {
    return {

      data: false,
      edit: {},
      action: '',
      table_key: new Date().getTime(),
      edit_pass: false,
      edit_question: false,
      warning_sign_key: new Date().getTime()
    }
  },

  methods: {

    get_limit: function () {
      return this.$store.getters.board_limits[this.$store.getters.user.membership]
    },
    remove_action: function () {
      this.action = false
      this.update_table()
    },
    update_table: function () {
      this.table_key = new Date().getTime()
      this.get_data()
    },

    change_route (value, row, column, component) {
      this.$route.params.id = this.$store.getters.boards[row].ID
      this.$router.push({ name: 'board_settings', params: this.$route.params })
    },

    get_details: function (value, row, column, component) {
      this.edit = {row: row, value: value, column: column}
      this.action = component
    },

    set_clone_board: function (index) {
      var my_class = this

      var clone = JSON.parse(JSON.stringify(this.$store.getters.boards[index]))
      clone.ID = new Date().getTime()

      this.$store.dispatch('set_new_board', {
        callback: function () { my_class.update_table() },
        data: clone
      })
    },

    add_new_board: function () {
      var my_class = this

      this.$store.dispatch('set_new_board', {
        callback: function () { my_class.update_table() },
        data: {
          ID: new Date().getTime(),
          pass: '',
          name: this.$tc('message.board', 1),
          data: [[this.$tc('demo.questions', 1)], [this.$tc('demo.questions', 2)]],
          creation_time: new Date().getDay() + '.' + new Date().getMonth() + 1 + '.' + new Date().getFullYear() + ' ' + new Date().getHours() + ':' + new Date().getMinutes(),
          update_time: new Date().getDay() + '.' + new Date().getMonth() + 1 + '.' + new Date().getFullYear() + ' ' + new Date().getHours() + ':' + new Date().getMinutes()
        }
      })
    },

    get_data () {
		 var my_class = this
	 	 var r = []

	 		for (var i = 0; i < this.$store.getters.boards.length; i++) {
        var data = {}

        data['#'] = this.$store.getters.boards[i].ID
        data[my_class.$tc('message.board', 1)] = this.$store.getters.boards[i].name
        data[my_class.$tc('message.question', 2)] = this.$store.getters.boards[i].data.length + ' ' + my_class.$tc('message.question', this.$store.getters.boards[i].data.length)

        if (!this.$store.getters.boards[i].pass) data[my_class.$tc('message.password', 1)] = my_class.$t('message.add', { name: my_class.$t('message.password') })
        else data[my_class.$tc('message.password', 1)] = my_class.$t('message.edit', { name: my_class.$t('message.password') })

        data[my_class.$tc('message.settings', 2)] = my_class.$tc('message.settings', 2)

        if (this.get_limit() && this.get_limit() > this.$store.getters.boards.length) { data[my_class.$t('message.duplicate')] = my_class.$t('message.duplicate') }
        // data[my_class.$tc("message.website", 2)] = my_class.$t("message.goTo", {name: my_class.$tc("message.website", 2)});
        // data[my_class.$tc("message.embed", 2)] = my_class.$t("message.embed");

	 			r.push(data)
	 		};

	 		return r
	  }

  },

  mounted () {
    this.$store.dispatch('get_user_boards')
    this.$store.dispatch('get_all_votes')
  },

  metaInfo: function () {
    return {
      title: this.$t('message.edit', {name: this.$tc('message.board', 2) })
    }
  }

}

</script>

<style scoped>

	.handle{
		cursor: move;
	}

	.hit-html-h3{
		margin-top: 0;
		margin-bottom: 20px;
		border-bottom: 2px dotted lightgrey;
	}
	.hit-html-h3:focus{
	outline: none;

	border-bottom: 2px dotted darkgrey;
	box-sizing: border-box;
	font-weight: bold;
	}
</style>
